import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AsinSkuFilter } from "../filters/AsinSkuFilter";
import { useAppController, streamOptions } from "../../hooks/useAppController";

const AsinSkuFilterRoute: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const controller = useAppController();

  // Sales dashboard flow removed

  const handleCancel = () => {
    controller.setAsinSkuValue("");
    controller.setStartDate(null);
    controller.setEndDate(null);
    
    // Navigate back to home
    history.push("/");
  };

  const handleSubmit = async () => {
    await controller.handleASINSKUSubmit();
  };

  return (
    <AsinSkuFilter
      asinSkuValue={controller.asinSkuValue}
      setAsinSkuValue={controller.setAsinSkuValue}
      startDate={controller.startDate}
      endDate={controller.endDate}
      setStartDate={controller.setStartDate}
      setEndDate={controller.setEndDate}
      hasDateRange={controller.hasDateRange}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      showFilterSuccess={controller.showFilterSuccess}
      streamOptions={streamOptions}
      formatDate={controller.formatDate}
    />
  );
};

export default AsinSkuFilterRoute;
